import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { MAINTENANCE_FAIL_MODE_PATH } from '../../../../config/paths';
import {
  clearMaintenanceFailMode,
  getMaintenanceFailMode,
} from '../../../../actions/mechanical-maintenance';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import MaintenanceFailModeBasicInformationResource from './resource/MaintenanceFailModeBasicInformationResource';
import MaintenanceFailModeToolbar from './MaintenanceFailModeToolbar';
import MaintenanceFailModeCategoryBasicInformationResource from './resource/MaintenanceFailModeCategoryBasicInformationResource';
import MaintenanceFailModeActivityBasicInformationResource from './resource/MaintenanceFailModeActivityBasicInformationResource';

export const MaintenanceFailMode = ({
  breadcrumbs,
  dispatchGetMaintenanceFailMode,
  dispatchClearMaintenanceFailMode,
  match: {
    params: { id: maintenanceFailModeId },
  },
  loading,
  maintenanceFailMode,
}) => {
  useLayoutEffect(() => {
    dispatchGetMaintenanceFailMode({ maintenanceFailModeId });

    return () => dispatchClearMaintenanceFailMode();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (maintenanceFailMode.isEmpty())
    content = <NoDataResource returnPage={MAINTENANCE_FAIL_MODE_PATH} />;
  else {
    const maintenanceFailModeJson = maintenanceFailMode.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <MaintenanceFailModeBasicInformationResource
          {...maintenanceFailModeJson}
        />

        <div className="mb-3">
          <h3>Categorías de Falla</h3>
          <MaintenanceFailModeCategoryBasicInformationResource
            {...maintenanceFailModeJson}
          />
        </div>

        <h3>Actividades Asignadas</h3>
        <MaintenanceFailModeActivityBasicInformationResource
          {...maintenanceFailModeJson}
        />
      </>
    );

    toolbar = (
      <MaintenanceFailModeToolbar
        maintenanceFailModeId={maintenanceFailModeJson.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Modo de Falla"
      content={content}
    />
  );
};

MaintenanceFailMode.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearMaintenanceFailMode: PropTypes.func.isRequired,
  dispatchGetMaintenanceFailMode: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  maintenanceFailMode: PropTypes.instanceOf(Immutable.Map).isRequired,
};

MaintenanceFailMode.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearMaintenanceFailMode: clearMaintenanceFailMode,
  dispatchGetMaintenanceFailMode: getMaintenanceFailMode,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Modos de Falla',
      href: MAINTENANCE_FAIL_MODE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  maintenanceFailMode: MechanicalMaintenanceUnit.MaintenanceFailMode.getIn([
    'current',
    'content',
  ]),
  loading: !MechanicalMaintenanceUnit.MaintenanceFailMode.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MaintenanceFailMode);
